import React from 'react';
import { motion } from 'framer-motion';
import { Target, Eye, Award } from 'lucide-react';
import { companyInfo } from '../mock';

export const About = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6 }
    }
  };

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={containerVariants}
          className="space-y-16"
        >
          {/* Section Header */}
          <div className="text-center space-y-4">
            <motion.span
              variants={itemVariants}
              className="inline-block px-4 py-2 bg-[#2196F3]/10 text-[#2196F3] rounded-full text-sm font-semibold"
            >
              About THAVAI
            </motion.span>
            <motion.h2
              variants={itemVariants}
              className="text-4xl md:text-5xl font-bold text-[#071B4D]"
            >
              Innovation-First Technology Partner
            </motion.h2>
            <motion.p
              variants={itemVariants}
              className="max-w-3xl mx-auto text-lg text-gray-600"
            >
              Empowering global enterprises with cutting-edge technology solutions
              and strategic digital transformation expertise.
            </motion.p>
          </div>

          {/* Vision, Mission, Values */}
          <div className="grid md:grid-cols-3 gap-8">
            <motion.div
              variants={itemVariants}
              className="group p-8 bg-gradient-to-br from-white to-blue-50/50 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100"
            >
              <div className="w-14 h-14 bg-[#2196F3]/10 rounded-xl flex items-center justify-center mb-6 group-hover:bg-[#2196F3] transition-colors duration-300">
                <Eye className="w-7 h-7 text-[#2196F3] group-hover:text-white transition-colors duration-300" />
              </div>
              <h3 className="text-2xl font-bold text-[#071B4D] mb-4">Vision</h3>
              <p className="text-gray-600 leading-relaxed">
                {companyInfo.vision}
              </p>
            </motion.div>

            <motion.div
              variants={itemVariants}
              className="group p-8 bg-gradient-to-br from-white to-blue-50/50 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100"
            >
              <div className="w-14 h-14 bg-[#2196F3]/10 rounded-xl flex items-center justify-center mb-6 group-hover:bg-[#2196F3] transition-colors duration-300">
                <Target className="w-7 h-7 text-[#2196F3] group-hover:text-white transition-colors duration-300" />
              </div>
              <h3 className="text-2xl font-bold text-[#071B4D] mb-4">Mission</h3>
              <p className="text-gray-600 leading-relaxed">
                {companyInfo.mission}
              </p>
            </motion.div>

            <motion.div
              variants={itemVariants}
              className="group p-8 bg-gradient-to-br from-white to-blue-50/50 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100"
            >
              <div className="w-14 h-14 bg-[#2196F3]/10 rounded-xl flex items-center justify-center mb-6 group-hover:bg-[#2196F3] transition-colors duration-300">
                <Award className="w-7 h-7 text-[#2196F3] group-hover:text-white transition-colors duration-300" />
              </div>
              <h3 className="text-2xl font-bold text-[#071B4D] mb-4">Core Values</h3>
              <ul className="space-y-2">
                {companyInfo.values.map((value, index) => (
                  <li key={index} className="text-gray-600 flex items-center gap-2">
                    <span className="w-1.5 h-1.5 bg-[#2196F3] rounded-full"></span>
                    {value}
                  </li>
                ))}
              </ul>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};